import {
    PRODUCTS_BY_TYPE_LOADING, PRODUCTS_DATA_SUCCESS, PRODUCTS_DATA_ERROR
} from "../actions/actionProduct";

const initialState = {
    products: [],
    loading: false,
    error: ''
};

function reducerProduct(state = initialState, action) {
    switch (action.type) {
        case PRODUCTS_BY_TYPE_LOADING: {
            return {
                ...state,
                loading: true,
                products:[],
                error: ''
            };
        }

        case PRODUCTS_DATA_SUCCESS: {
            return {
                ...state,
                loading: false,
                products: action.payload,
                error: ''
            };
        }

        case PRODUCTS_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                products: [],
                error: action.error
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerProduct;